<template>
    <span class="ds-legend" :title="tooltip">
        <span v-if="pct" class="ds-legend__pct">{{ pct }}</span>
        <span v-if="delta !== null" class="ds-legend__delta" :class="deltaClass">
            <ds-icon :name="deltaIcon" :size="15" />
            {{ Math.abs(delta).toLocaleString('pt-BR') }}
        </span>
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: 'DsLegend',
    props: {
        pct: { type: String, default: null },
        delta: { type: Number, default: null },
        tooltip: { type: String, default: null },
    },
    computed: {
        deltaClass() {
            if (this.delta > 0) return 'ds-legend__delta--up'
            if (this.delta < 0) return 'ds-legend__delta--down'
            return 'ds-legend__delta--flat'
        },
        deltaIcon() {
            if (this.delta > 0) return 'arrow_upward'
            if (this.delta < 0) return 'arrow_downward'
            return 'remove'
        },
    },
}
</script>

<style scoped>
.ds-legend { display: inline-flex; align-items: center; gap: var(--space-2); cursor: help; flex-wrap: wrap; }
.ds-legend__pct {
    font: var(--weight-medium) 15px/1 var(--font-ui);
    color: var(--blue-700);
    background: var(--info-soft);
    border-radius: var(--radius-pill);
    padding: 4px 10px;
}
.ds-legend__delta {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font: var(--weight-medium) 13px/1 var(--font-ui);
    border-radius: var(--radius-pill);
    padding: 4px 8px 4px 6px;
}
.ds-legend__delta--up { color: var(--success); background: var(--success-soft); }
.ds-legend__delta--down { color: var(--danger); background: var(--danger-soft); }
.ds-legend__delta--flat { color: var(--text-muted); background: var(--gray-150); }
</style>
